import React, { useState } from "react";
import { subscriptionAPI } from "../../../billing/utils/API";
import { SubscriptionType, SUBSCRIPTION_PRICES } from "common/components/subscription/types/SubscriptionTypes";
import './styles/SubscriptionButton.css';

interface SubscribeButtonProps {
  email: string;
  subscriptionType: SubscriptionType;
  onIgnore?: () => void;
}

export const SubscribeButton: React.FC<SubscribeButtonProps> = ({
  email,
  subscriptionType,
  onIgnore
}) => {
  const [loading, setLoading] = useState(false);

  const price = SUBSCRIPTION_PRICES[subscriptionType];
  const label =
  subscriptionType === SubscriptionType.FREE
    ? "Free Plan – €0"
    : subscriptionType === SubscriptionType.MONTHLY
    ? `Monthly – €${price}`
    : `Annual – €${price}`;

  const handleClick = async () => {
    
    if(subscriptionType === SubscriptionType.FREE && onIgnore){
      onIgnore();
      return;
    }

    setLoading(true);
    try {
      const data = await subscriptionAPI.createCheckoutSession(
        email,
        subscriptionType
      );

      if (data.url) {
        window.location.href = data.url;
      }
    } catch (err) {
      console.error("Error creating checkout session", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      disabled={loading}
      onClick={handleClick}
      className={`subscription-btn ${subscriptionType.toLowerCase()}`}
    >
      {loading ? "Redirecting..." : label}
    </button>
  );
};
